import React from 'react';

interface CaptchaProps {
  locale: string;
  onChange: (newVal: { [key: string]: any }) => void;
  getRefreshRef?: Function;
}

class Captcha extends React.Component<CaptchaProps, any> {

  private captcha: any;
  public saveCaptcha = (node: HTMLDivElement) => {
    this.captcha = node;
  }
  public componentDidMount() {
    const { getRefreshRef } = this.props;
    this.initCaptcha();
    getRefreshRef && getRefreshRef(this.initCaptcha);
  }
  public initCaptcha(refreshObj?: any) {
    const { locale = 'zh-CN', onChange } = this.props;
    const attrLocale = locale || refreshObj.locale;
    const attrOnChange = onChange || refreshObj.onChange;
    // @ts-ignore
    initNECaptcha({
      captchaId: '8574f509627c4fac9af62c23397bd0f6',
      element: '#captcha',
      mode: 'float',
      width: '100%',
      lang: attrLocale,
      onVerify: (err: any, ret: any) => {
        if (!err) {
          // ret['validate'] 获取二次校验数据
          attrOnChange({
            verifyCode: ret.validate,
          });
        }
      },
    }, function onload(instance: any) {
      // 初始化成功后，用户输入对应用户名和密码，以及完成验证后，直接点击登录按钮即可
    }, function onerror(err: any) {
        // 验证码初始化失败处理逻辑，例如：提示用户点击按钮重新初始化
    });
  }

  public render() {
    return (
      <div id="captcha" ref={this.saveCaptcha} />
    );
  }
}

export default Captcha;
